import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agent-asist',
  templateUrl: './agent-asist.component.html',
  styleUrls: ['./agent-asist.component.css']
})
export class AgentAsistComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

 
}
